// 判断是否 Safari 浏览器
const SAFARI_FILTER = ['FingerBrowser', 'baidubrowser', 'MQQBrowser', 'QBWebViewUA', 'QBWebViewType', 'WKType', 'GDTMobSDK', 'OPiOS']
export const judgeBrowserSafari = (userAgent) => {
  if (!userAgent.includes('Safari')) {
    return false
  }
  const list = SAFARI_FILTER.filter((item) => userAgent.includes(item))
  return !list.length
}

export default {
  state: {
    $loading: false,

    $isAndroid: false,
    $isIos: false,
    $isAndroidApp: false,
    $isIosApp: false,
    $isApp: false,
    $isWechat: false,
    $isSafari: false
  },
  mutations: {
    basicRootMutations(state, payload) {
      Object.assign(state, payload)
    }
  },
  actions: {
    async setSystem({ commit }) {
      const userAgent = navigator.userAgent

      // Android 终端
      const $isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1

      // Ios 终端
      const $isIos = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

      // 安卓 APP
      const $isAndroidApp = userAgent === 'app/android'

      // ios APP
      const $isIosApp = userAgent === 'app/ios'

      // APP
      const $isApp = $isAndroidApp || $isIosApp

      // 微信浏览器
      const $isWechat = userAgent.indexOf('MicroMessenger') !== -1

      // Safari浏览器
      const $isSafari = judgeBrowserSafari(userAgent)

      commit('basicRootMutations', { $isAndroid, $isIos, $isAndroidApp, $isIosApp, $isApp, $isWechat, $isSafari })
    },

    // 下载 APP
    downloadApp() {
      window.location.href = 'https://www.baidu.com'
    }
  }
}
